const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const ClassNames = require('classnames');

// @ helpers
const {
    BROKER_INPUT_SEARCH_FUNDS_TYPE
} = require('constants/index');

class FundsOption extends React.Component {

    constructor(props) {
        super(props);
        this.handleMouseDown = this.handleMouseDown.bind(this);
    }

    handleMouseDown (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option);
    }

    render() {

        const {isFocused, option} = this.props;

        let optionElement=<span></span>;

        if (!option.disabled && !option.showMoreLink && option.type === BROKER_INPUT_SEARCH_FUNDS_TYPE) {
            const optionsClass = ClassNames('broker-search-input-option__results-item', {
                'broker-search-input-option__results-item--focus': isFocused
            });
            const {term, label} = option;
            const field = label.toLowerCase();
            const termIndex = field.indexOf(term);

            if (termIndex !== -1) {
                const fieldLeft = label.slice(0, termIndex);
                const fieldRight = label.slice(termIndex + term.length, field.length);
                const untouchedTerm = label.slice(termIndex, termIndex + term.length);

                optionElement = (
                    <div className={optionsClass}
                        onMouseDown={this.handleMouseDown}
                    >
                        {fieldLeft}<span>{untouchedTerm}</span>{fieldRight}
                    </div>
                );
            } else {
                optionElement = (
                    <div className={optionsClass}
                        onMouseDown={this.handleMouseDown}
                    >
                        {label}
                    </div>
                );
            }
        }

        return optionElement;
    }
}

FundsOption.propTypes = {
    option: PropTypes.object.isRequired,
    isFocused: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
};

module.exports = FundsOption;